<template>
    <div class="animated fadeIn">
        <component-header
            title="Portfolio Management"
            :isLoading="loading"
            :hasSearch="true"
            :hasReload="false"
            @search-query="getPortfolioListData"
            :hasDropdown="true"
            :hasfilterOptions="filterOptions"
            :selectedOption="selectedFilter"
            @select-query="selectPortfolioBy"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.go(-1)"
        />
        <b-card v-if="!addAsset">
            <b-row class="mb-3" v-if="filteredList.length">
                <b-col md="2">
                    <h4 class="ml-2">Assets List</h4>
                </b-col>
                <b-col md="8"></b-col>
                <b-col md="2" class="text-right">
                    <b-button
                        class="export-btn"
                        size="sm"
                        variant="success"
                        @click="createNewAsset"
                    >
                        <i class="fa fa-plus"></i>
                        <span class="ml-1">Add New Asset</span>
                    </b-button>
                </b-col>
            </b-row>
            <div class="text-center" v-if="loading">
                <p>
                    <b>Loading....</b>
                </p>
            </div>
            <div v-if="filteredList.length">
                <div class="">
                    <b-table
                        style="border-radius: 12px"
                        id="portfolio-table"
                        :dark="false"
                        :hover="true"
                        :striped="true"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive
                        class="tableRadius"
                        :items="filteredList"
                        :fields="portfolioColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        filter
                        thead-class="header"
                        show-empty
                        :busy="loading"
                    >
                        <template slot="action" slot-scope="data">
                            <div class="inline_btnTable">
                                <b-button
                                    size="sm"
                                    class="button-circle mr-2"
                                    variant="primary"
                                    @click="editPortfolio(data.item)"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>

                                <b-button
                                    size="sm"
                                    class="button-circle mr-2"
                                    @click="deletePortfolio(data.item)"
                                    variant="danger"
                                >
                                    <i class="fa fa-trash"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filteredList.length"
                        aria-controls="partner-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                        @change="getPortfolioData"
                    ></b-pagination>
                </div>
            </div>
            <b-row v-if="!loading && !filteredList.length">
                <b-col md="12" class="text-center">
                    <img src="img/customerCare.png" alt="Customer Care" />
                </b-col>
            </b-row>
        </b-card>
        <b-card v-if="addAsset">
            <add-new-asset @cancel="reloadAsset"></add-new-asset>
        </b-card>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import addNewAsset from "@/components/Portfolio/addNewAsset.vue";
import { mapState } from "vuex";

export default {
    components: {
        ComponentHeader,
        addNewAsset,
    },
    data() {
        return {
            loading: false,
            selectedFilter: "mobileNumber",
            search: "",
            filterOptions: [
                { text: "Mobile Number", value: "mobileNumber" },
                { text: "Email", value: "email" },
            ],
            portfolioColumns: [
                {
                    label: "Asset Name",
                    key: "name",
                },
                {
                    label: "Category",
                    key: "Category",
                },
                {
                    label: "Current Price",
                    key: "price",
                },
                {
                    label: "Quantity",
                    key: "quantity",
                },
                {
                    label: "Final Price",
                    key: "final_price",
                },
                {
                    label: "24h Charge",
                    key: "24h Charge",
                },
                {
                    key: "action",
                },
            ],
            perPage: 10,
            currentPage: 1,
            addAsset: false,
        };
    },
    computed: {
        ...mapState({
            portfolioList: (state) => state.portfolio.portfolioList,
            portfolioDataList: (state) => state.portfolio.portfolioDataList,
        }),
        filteredList() {
            let allItems = [];
            if (Array.isArray(this.portfolioDataList)) {
                this.portfolioDataList.forEach((obj) => {
                    if (obj && Array.isArray(obj.items)) {
                        allItems = [...allItems, ...obj.items];
                    }
                });
            }
            return allItems;
        },
    },
    methods: {
        async createNewAsset() {
            this.addAsset = true;
            let catalogDomainData = this.$currentUserData.catalogInfo;
            let payload = {
                category: true,
                catalogId: catalogDomainData[0].catalogId,
            };
            await this.$store.dispatch(
                "portfolio/fetchSubCategoriesAction",
                payload
            );
        },
        async getPortfolioData(e) {
            this.currentPage = e;
            await this.getPortfolioListData(this.search);
        },
        selectPortfolioBy(val) {
            this.selectedFilter = val;
            // this.getPortfolioListData();
        },
        reloadAsset() {
            this.getPortfolioListData(this.search);
            this.addAsset = false;
        },
        async getPortfolioListData(val) {
            if (!val) {
                this.$store.commit("portfolio/portfolioData", []);
                return;
            }
            this.search = val;
            if (
                this.selectedFilter === "mobileNumber" &&
                this.search.length !== 10
            ) {
                return;
            }
            this.loading = true;
            const payload = {
                keyword: val,
            };
            await this.$store.dispatch(
                "portfolio/searchPortfolioByNumber",
                payload
            );
            if (
                this.selectedFilter === "mobileNumber" &&
                !this.portfolioList.length
            ) {
                this.$swal({
                    title: "Error",
                    text: "Enter a Valid Phone Number.",
                    type: "error",
                });
                this.loading = false;
                return;
            }
            let data = this.$store.getters["portfolio/GetPortfolios"];
            if (data.length) {
                let userId = data[0]._id;
                await this.$store.dispatch(
                    "portfolio/fetchPortfolioDetails",
                    userId
                );
            }
            if (
                this.selectedFilter === "mobileNumber" &&
                !this.portfolioDataList.length
            ) {
                this.$swal({
                    title: "Error",
                    text: "Enter a Valid Phone Number.",
                    type: "error",
                });
                this.loading = false;
                return;
            }
            this.loading = false;
        },
        async deletePortfolio(item) {
            let payload = { id: item._id, status: { status: "Closed" } };
            await this.$store.dispatch("portfolio/removeAsset", payload);
        },
    },
    mounted() {
        this.$store.commit("portfolio/portfolioData", []);
    },
};
</script>
